import { inject } from '@angular/core';
import { collectionSnapshots, getDocs } from '@angular/fire/firestore';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { accessDatabase, AuthService, CommonService, databaseCollector, EventDatabase, LayoutService } from '@seasidebeta/components';
import { Event } from '@seasidebeta/types';
import { usersDatabase } from '../../database';
import { CacheService } from '@seasidebeta/components';

export const findEventResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> => {

    const as = inject(AuthService)
    const router = inject(Router)
    const layout = inject(LayoutService)
    const accessdb = inject(accessDatabase)
    const eventdb = inject(EventDatabase)
    const common = inject(CommonService)
    const cache = inject(CacheService)
    const userdb = inject(usersDatabase)
    const dbColl = inject(databaseCollector)
    const routerId = route.params.routerId
    var hasAccess: boolean = false

    return new Promise((res, rej) => {
        common.unsubscribe('find-event-resolver')
        const findEventPromise = new Promise<Event.Access.EventUserAccess>(async (resolve, reject) => {
            // const routeFestivalsPromise = new Promise((resolve, reject) => {
            if (eventdb.currentEvent.routerId != routerId) {
                if (accessdb.userAccess) {
                    const userCurrentEventAccess = accessdb.userAccessEvents.filter(accessEvent => accessEvent.routerId == routerId)
                    // console.log(userCurrentEventAccess)
                    if (userCurrentEventAccess.length == 0) {
                        await accessdb.getEventAccessFromEventRouterId(routerId).then(eventAccess => {
                            if (eventAccess) {
                                userCurrentEventAccess.push(eventAccess)
                            }
                        }).catch(err => {
                            console.log(err)
                        })
                    }
                    if (accessdb.userAccess.admin || accessdb.currentCustomerAccess.access?.admin) {
                        console.log('admin!')
                        // getDocs(eventdb.getFestivalDataCollectionFromRouterID(routerId)).then(eventsColl => {
                        //     const size = eventsColl.size
                        //     const doc = eventsColl.docs[0]
                        collectionSnapshots(eventdb.getFestivalDataCollectionFromRouterID(routerId)).subscribe(eventsColl => {
                            const size = eventsColl.length
                            const doc = eventsColl[0]
                            if (size > 0) {
                                
                                let festivalExtended = eventdb.setEvent(doc.data())
                                eventdb.mainGroups = convertMainGroups(festivalExtended)
                                let festivalUserAccess: Event.Access.EventUserAccess = {
                                    eventAccess: {
                                        admin: true
                                    },
                                    eventId: eventdb.currentEvent.id
                                }
                                if (userCurrentEventAccess.length > 0) {
                                    festivalUserAccess = userCurrentEventAccess[0]
                                    if (!festivalUserAccess.eventAccess) festivalUserAccess.eventAccess = {}
                                    festivalUserAccess.eventAccess.admin = true
                                }
                                accessdb.setcurrentEventUserAccess(festivalUserAccess)
                                if (accessdb.currentEventAccess.eventAccess?.accomodationCustomDateActive) {
                                    // console.log('accomodationCustomDateActive', accessdb.currentEventAccess.eventAccess?.accomodationCustomDateActive)
                                    if (!festivalExtended.dates) festivalExtended.dates = {}
                                    if (accessdb.currentEventAccess.eventAccess?.accomodationCustomDateStart) festivalExtended.dates.accomodationStart = common.convertFirestoreTimestamp(accessdb.currentEventAccess.eventAccess?.accomodationCustomDateStart)
                                    if (accessdb.currentEventAccess.eventAccess?.accomodationCustomDateEnd) festivalExtended.dates.accomodationEnd = common.convertFirestoreTimestamp(accessdb.currentEventAccess.eventAccess?.accomodationCustomDateEnd)
                                    festivalExtended = eventdb.setEvent(festivalExtended)
                                    // festivalExtended = eventdb.processEventData(festivalExtended, true)
                                    // eventdb.currentEvent = festivalExtended
                                }
                                festivalUserAccess.eventData = festivalExtended
                                layout.generateEventModules(festivalExtended, accessdb.currentEventAccess);
                                layout.generateEventModulesV2(festivalExtended, accessdb.currentEventAccess);
                                resolve(accessdb.currentEventAccess);
                            } else {
                                reject('No event found by route...')
                                router.navigate(['error'])
                            }
                        })
                    } else {
                        console.log('bruker!')
                        if (userCurrentEventAccess.length > 0) {
                            getDocs(eventdb.getFestivalDataCollectionFromRouterID(routerId)).then(eventsColl => {
                                if (eventsColl.size > 0) {
                                    let festivalExtended = eventdb.setEvent(eventsColl.docs[0].data())
                                    // if (festivalExtended.eventDays) eventdb.eventDays = festivalExtended.eventDays
                                    // if (festivalExtended.programDays) eventdb.eventDays = festivalExtended.programDays
                                    // if (festivalExtended.accomodationDays) eventdb.accomodationDays = festivalExtended.accomodationDays
                                    // eventdb.currentEvent = festivalExtended
                                    userCurrentEventAccess[0].eventData = festivalExtended
                                    eventdb.mainGroups = convertMainGroups(festivalExtended)
                                    accessdb.setcurrentEventUserAccess(userCurrentEventAccess[0])
                                    // console.log(accessdb.currentEventAccess)
                                    if (accessdb.currentEventAccess.eventAccess?.accomodationCustomDateActive) {
                                        // console.log('accomodationCustomDateActive', accessdb.currentEventAccess.eventAccess?.accomodationCustomDateActive)
                                        if (!festivalExtended.dates) festivalExtended.dates = {}
                                        if (accessdb.currentEventAccess.eventAccess?.accomodationCustomDateStart) festivalExtended.dates.accomodationStart = common.convertFirestoreTimestamp(accessdb.currentEventAccess.eventAccess?.accomodationCustomDateStart)
                                        if (accessdb.currentEventAccess.eventAccess?.accomodationCustomDateEnd) festivalExtended.dates.accomodationEnd = common.convertFirestoreTimestamp(accessdb.currentEventAccess.eventAccess?.accomodationCustomDateEnd)
                                        festivalExtended = eventdb.setEvent(festivalExtended)
                                        // festivalExtended = eventdb.processEventData(festivalExtended, true)
                                        // eventdb.currentEvent = festivalExtended
                                        // console.log(festivalExtended.id, festivalExtended.fullName, festivalExtended)
                                    }
                                    // console.log(userCurrentEventAccess[0])
                                    layout.generateEventModules(festivalExtended, userCurrentEventAccess[0]);
                                    layout.generateEventModulesV2(festivalExtended, userCurrentEventAccess[0]);
                                    resolve(userCurrentEventAccess[0]);
                                } else {
                                    reject('No event found by route...')
                                    router.navigate(['error'])
                                }
                            })
                        } else {
                            eventdb.setEvent(null)
                            // eventdb.currentEvent = null
                            router.navigate(['/accessdenied']);
                        }
                    }
                } else {
                    console.log('Fant ingen access')
                    resolve({})
                }
            } else {
                resolve({});
            }
            // })
            // Promise.all([routeFestivalsPromise]).then(function(values) {
            //     resolve(true)
            // })
        })
        findEventPromise.then(async festivalUserAccess => {
            // WORKTASK FETCH AND CATCHING
            const worktasksCacheInfo = await cache.getCacheInfo('worktasks', eventdb.currentEvent.id) ?? {}
            let forceWorktasks = false
            if (worktasksCacheInfo) {
                if (eventdb.currentEvent.timestamps && eventdb.currentEvent.timestamps.worktasksLastEdited) {
                    if (worktasksCacheInfo.timestamp) worktasksCacheInfo.timestamp = new Date(worktasksCacheInfo.timestamp).getTime()
                    // console.log(worktasksCacheInfo.timestamp, eventdb.currentEvent.timestamps.worktasksLastEdited.getTime())
                    if (worktasksCacheInfo.timestamp) {
                        if (worktasksCacheInfo.timestamp < eventdb.currentEvent.timestamps.worktasksLastEdited.getTime()) forceWorktasks = true
                    }
                }
            }
            let worktasks: Event.Worktask[] = await cache.getCache('worktasks', eventdb.currentEvent.id) ?? []
            // console.log(worktasks)
            // console.log('force', force)
            if (!worktasks || worktasks.length == 0 || forceWorktasks) {
                getDocs(eventdb.getWorktasks(eventdb.currentEvent.id)).then(worktasksColl => {
                    eventdb.worktasks = worktasksColl.docs.map(snap => snap.data() as Event.Worktask)
                    // console.log(eventdb.worktasks)
                    cache.setCache('worktasks', eventdb.currentEvent.id, eventdb.worktasks, 604800000) //1 uke cache
                    res(true)
                })
                if (forceWorktasks) {
                    console.log('worktasks out of date, fetching new')
                } else {
                    console.log('worktasks not cached')
                }
            } else {
                console.log('worktasks cached')
                eventdb.worktasks = worktasks
                res(true)
            }

            // LOCATIONS FETCH AND CATCHING
            const locationsCacheInfo = await cache.getCacheInfo('locations', eventdb.currentEvent.id) ?? {}
            let forceLocations = false
            if (locationsCacheInfo) {
                if (eventdb.currentEvent.timestamps && eventdb.currentEvent.timestamps.locationsLastEdited) {
                    if (locationsCacheInfo.timestamp) locationsCacheInfo.timestamp = new Date(locationsCacheInfo.timestamp).getTime()
                    // console.log(locationsCacheInfo.timestamp, eventdb.currentEvent.timestamps.locationsLastEdited.getTime())
                    if (locationsCacheInfo.timestamp) {
                        if (locationsCacheInfo.timestamp < eventdb.currentEvent.timestamps.locationsLastEdited.getTime()) forceLocations = true
                    }
                }
            }
            let locations: Event.Worktask[] = await cache.getCache('locations', eventdb.currentEvent.id) ?? []
            // console.log(locations)
            // console.log('forceLocations', forceLocations)
            if (!locations || locations.length == 0 || forceLocations) {
                eventdb.locations = []
                getDocs(eventdb.getLocations(eventdb.currentEvent.id)).then(locationsColl => {
                    eventdb.locations = locationsColl.docs.map(loc => {
                        let location: Event.Location.Location = loc.data()
                        return location
                    })
                    cache.setCache('locations', eventdb.currentEvent.id, eventdb.locations, 604800000) //1 uke cache
                    eventdb.locations.forEach(location => {
                        if (dbColl.accessToLocation(location.id)) location.editable = true
                    })
                })
                if (forceLocations) {
                    console.log('locations out of date, fetching new')
                } else {
                    console.log('locations not cached')
                }
            } else {
                console.log('locations cached')
                eventdb.locations = locations
                eventdb.locations.forEach(location => {
                    if (dbColl.accessToLocation(location.id)) location.editable = true
                })
                res(true)
            }
        })
    })

}

function convertMainGroups(eventData: Event.Event) {
    const mainGroups: Event.MainGroup[] = []
    if (eventData.mainGroups) {
        Object.keys(eventData.mainGroups).forEach(key => {
            if (eventData.mainGroups[key].active != false) mainGroups.push(eventData.mainGroups[key])
        })
    }
    mainGroups.sort((a, b) => {
        if (a.sortId > b.sortId) return 1
        if (a.sortId < b.sortId) return -1
        return 0
    })
    // console.log(mainGroups)
    return mainGroups
}